import DataStore, { Query } from 'src/core/stores/data-store';
import {
  CreateLicenseDataItem,
  CsvReportRequest,
  LicenseCreationAttributes,
  LicenseDataItem,
  LicenseDataSummaryItem,
  LicenseSuggestions,
  LicenseSuggestionsRequest,
  LicenseScopeRequest,
  NewLicensCreationAttributes,
} from 'src/stores/licensing-store';
import { LicenseDataSummaryMockData } from '../data-sources/license-data-summary';
import FormStoreMock from './base/form-store';
import { LicenseCreationAttributesMockData } from '../data-sources/license-creation-attributes';
import DataStoreMock from './base/data-store';
import { LicenseSummaryMockData } from '../data-sources/license-summary';
import { LicenseSuggestionsMockData } from '../data-sources/license-suggestions';
import { LicenseDataItemMockData } from '../data-sources/license-data-item';

export class LicenseDataSummaryStoreMock extends DataStoreMock<LicenseDataSummaryItem> {
  public async load(query: Partial<Query>): Promise<any> {
    this._state.set({
      isBusy: false,
      items: LicenseDataSummaryMockData,
      count: LicenseDataSummaryMockData.length,
    });
  }

  public async loadFromOrganizationIds(query: Partial<Query>): Promise<any> {
    this._state.set({
      isBusy: false,
      items: LicenseDataSummaryMockData,
      count: LicenseDataSummaryMockData.length,
    });
  }

  public async licenseExists(query: Partial<Query>, id: string = '') {
    return LicenseDataSummaryMockData[0];
  }
}

export class LicenseSummaryStoreMock extends FormStoreMock<string, string> {
  public async load(id: string) {
    this._state.set({
      isBusy: false,
      item: LicenseSummaryMockData,
    });
    return LicenseSummaryMockData as any;
  }
}

export class LicenseDataItemStoreMock extends FormStoreMock<LicenseDataItem, CreateLicenseDataItem> {
  public async load(id: string) {
    this._state.set({
      isBusy: false,
      item: LicenseDataItemMockData,
    });
    return LicenseDataItemMockData;
  }

  public async update(item: LicenseDataItem) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async updateSignOff(item: { signOff: boolean }, id: string) {
    return { data: LicenseCreationAttributesMockData, status: 200, statusText: 'OK', headers: {}, config: {} };
  }

  public dateDiffToHours(from: Date, until: Date) {
    const parsedFrom = new Date(from);
    const parsedUntil = new Date(until);
    return Math.abs(parsedUntil.getTime() - parsedFrom.getTime()) / 36e5;
  }

  public hoursToDateDiff(hours: number) {
    const from = new Date();
    const until = new Date(new Date().setTime(from.getTime() + hours * 36e5));
    return { from, until };
  }
}

export class LicenseSuggestionsStoreMock extends FormStoreMock<LicenseSuggestions, LicenseSuggestions> {
  public async load(id: string) {
    this._state.set({
      isBusy: false,
      item: LicenseSuggestionsMockData,
    });
    return LicenseSuggestionsMockData as any;
  }

  public async getSuggestions(request: LicenseSuggestionsRequest) {
    return true;
  }
}

export class ReportItemStoreMock extends DataStore<any> {
  public async get(item: CsvReportRequest) {
    return true;
  }
  public async getFull(query: Query, item: CsvReportRequest) {
    return true;
  }
}

export class LicenseCreationAttributesStoreMock extends FormStoreMock<LicenseCreationAttributes, NewLicensCreationAttributes> {
  public async load(id: string) {
    this._state.set({
      isBusy: false,
      item: LicenseCreationAttributesMockData,
    });
    return LicenseCreationAttributesMockData;
  }

  public async post(item: NewLicensCreationAttributes) {
    return { isSuccess: true, error: '', messages: [] };
  }
  public async createMany(items: NewLicensCreationAttributes[]) {
    return { isSuccess: true, error: '', messages: [] };
  }
  public async getByUserScope(item: LicenseScopeRequest) {
    this._state.set({
      isBusy: false,
      item: LicenseCreationAttributesMockData,
    });
    return true;
  }
  public async checkForLicenseAmountReset(item: LicenseScopeRequest) {
    return true;
  }
  public async deleteByUserScope(item: LicenseScopeRequest) {
    return { data: LicenseCreationAttributesMockData, status: 200, statusText: 'OK', headers: {}, config: {} };
  }
}
